<template>
  <ul class="search-results-list">
    <search-results-item
      v-for="(item, i) in results"
      :item="item"
      :key="`${item.id}_${item.type}_${i}`"
    />
  </ul>
</template>

<script>
import SearchResultsItem from './search-results-item'

export default {
  props: ['results'],
  components: {
    SearchResultsItem
  }
}
</script>

<style lang="less">
.search-results-list {
  max-height: 320px;
  overflow: auto;
}
</style>
